import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import {
    Link, useLocation, useNavigate, useParams
} from "react-router-dom";
import Breadcrumb from '../../Components/Breadcrumb';
import ShopForm from './form';
import ShopService from './service';


const ShopEdit: FC = () => {  
    const location: any = useLocation();
    const navigate = useNavigate();

    const shopService = new ShopService();

    let { id } = useParams();
    const { t } = useTranslation();

    const [shop, setShop] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        shopService.getShop(Number(id)).then(async function (response: any) {
            console.log(response); 
            setShop(response.data);
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }, []);

    return ( 
        <> 
            <Breadcrumb />

            <div className="container-fluid">

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">
                                    { t('Modifier une boutique') }
                                </h4>
                                <Link type="button" to="/boutique/list"
                                    className="btn waves-effect waves-light btn-primary">
                                    { t('Liste des boutiques') }
                                </Link>
                                <br />
                                <br />

                                { !loading && shop ?
                                    <ShopForm state='edit' shop={ shop } />  
                                    :
                                    <div className="spinner-border text-primary spinner-border-lg" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                }     
                                 
                                </div>
                            </div> 
                    </div> 
                </div>

            </div>   
        </>                   
    );
}

export default ShopEdit